module.exports = __webpack_public_path__ + "img/arrow-active.fcebeac1.svg";